import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { UpdateVideoSubmissionInputDto, VideoSubmissionDto } from "../../../models/video-review/dto/video-submission.dto";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_VIDEO_SUBMISSION_QUERY_KEY } from "./useGetVideoSubmission";

export const useUpdateVideoSubmission = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: ({ id, input }: { id: string; input: UpdateVideoSubmissionInputDto }) =>
            client.fetchApi<VideoSubmissionDto, UpdateVideoSubmissionInputDto>({
                endpoint: `video-submissions/${id}`,
                method: 'PATCH',
                body: input,
            }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_VIDEO_SUBMISSION_QUERY_KEY(data.id), data);
            queryClient.invalidateQueries({ queryKey: ['video-submissions', 'list', selectedOrganization?.id || ''] });
        },
    });
};
